import {Mic, MessageSquare} from 'lucide-react';

const SingleLabView = ({transcriptions, transcriptionsEndRef}) => {
    const combinedTranscript = transcriptions.map(t => t.transcript).join(' ');
    const combinedTranslation = transcriptions
        .filter(t => t.translation)
        .map(t => t.translation)
        .join(' ');
    const avgConfidence = transcriptions.reduce((sum, t) => sum + t.confidence, 0) / transcriptions.length;
    const firstTimestamp = transcriptions[0]?.timestamp;
    const lastTimestamp = transcriptions[transcriptions.length - 1]?.timestamp;


    return (
        <>
            <div className="glass-panel rounded-xl p-4 animate-slide-up">
                <div className="flex items-start gap-3">
                    <div
                        className="w-10 h-10  bg-accent-secondary rounded-full flex items-center justify-center flex-shrink-0">
                        <Mic className="w-5 h-5 text-white"/>
                    </div>

                    <div className="flex-1 min-w-0">
                        <div className="text-sm text-purple-400 font-semibold mb-2 flex items-center gap-2">
                            <MessageSquare className="w-4 h-4"/>
                            <span>Combined Transcript ({transcriptions.length} segments)</span>
                        </div>

                        <div className="text-white leading-relaxed mb-3">
                            {combinedTranscript}
                        </div>

                        {combinedTranslation && (
                            <div
                                className="text-sm text-purple-300 italic border-l-2 border-purple-500/50 pl-3 py-2 mt-3">
                                <span className="text-xs text-purple-400/70 block mb-1">Combined Translation:</span>
                                {combinedTranslation}
                            </div>
                        )}

                        <div className="flex items-center justify-between mt-4 pt-3 border-t border-white/10">
                            <div className="text-xs text-zinc-500">
                                {firstTimestamp && lastTimestamp && (
                                    <span>
                                                {new Date(firstTimestamp).toLocaleTimeString()} - {new Date(lastTimestamp).toLocaleTimeString()}
                                            </span>
                                )}
                            </div>

                            <div className="flex items-center gap-2">
                                {/*<div*/}
                                {/*    className={`text-xs ${avgConfidence >= 0.8 ? 'text-teal-500' : 'text-yellow-400'}`}>*/}
                                {/*    {avgConfidence >= 0.8 ? '✓' : '⚠️'} Avg: {(avgConfidence * 100).toFixed(0)}%*/}
                                {/*</div>*/}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div ref={transcriptionsEndRef}/>
        </>
    );

}

export default SingleLabView